export default __webpack_public_path__ + "static/media/priorities.6af64b55.svg";